var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-incoming",
    d: "m17.625 14.174 2.642 1.576a1.5 1.5 0 0 1 .7 1.583 4.526 4.526 0 0 1 -5.6 3.508 17.44 17.44 0 0 1 -12.208-12.206 4.526 4.526 0 0 1 3.507-5.6h.016a1.5 1.5 0 0 1 1.587.707l1.564 2.64a2.051 2.051 0 0 1 -.633 2.746l-1.657 1.105a11.6 11.6 0 0 0 6.211 6.226l1.115-1.665a2.052 2.052 0 0 1 2.756-.62zm2.905-10.704a.749.749 0 0 0 -1.06 0l-3.72 3.719v-1.522a.75.75 0 0 0 -1.5 0v3.333a.753.753 0 0 0 .75.75h3.333a.75.75 0 0 0 0-1.5h-1.522l3.719-3.72a.749.749 0 0 0 0-1.06z",
    fill: "rgb(0,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingAudio);
export default __webpack_public_path__ + "static/media/Incoming_Audio.574f91bd2fc898d261ce17536a74f0c2.svg";
export { ForwardRef as ReactComponent };